module.exports = __webpack_public_path__ + "static/media/reset.8bbb2411.svg";